import React from "react";
import { SnackbarProvider } from "notistack";


const ToastifyProvider = ({ children }) => {
  return (
    <SnackbarProvider
      maxSnack={3} 
      // style={{marginTop:"50px"}}
      // autoHideDuration={3000}
      anchorOrigin={{
        vertical: "top",
        horizontal: "center",

      }}
    >
      {children}
    </SnackbarProvider>
  );
};

export default ToastifyProvider;


